/**
 * StepCard — one of the "01/02/03" cards in the Landing → How it works
 * section. Big italic coral number on top, title in display serif,
 * body in ink-3.
 */
import { ReactNode } from 'react';

type Props = { num: string; title: string; body: ReactNode };

export function StepCard({ num, title, body }: Props) {
  return (
    <div
      style={{
        padding: 28,
        borderRadius: 20,
        background: 'var(--surface)',
        boxShadow: 'var(--shadow-card)',
      }}
    >
      <div
        className="serif"
        style={{
          fontSize: 56,
          fontWeight: 500,
          fontStyle: 'italic',
          color: 'var(--coral)',
          lineHeight: 1,
          letterSpacing: -2,
        }}
      >
        {num}
      </div>
      <div
        className="serif"
        style={{
          fontSize: 24,
          fontWeight: 500,
          letterSpacing: -0.5,
          marginTop: 16,
          lineHeight: 1.15,
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 14, color: 'var(--ink-3)', marginTop: 8, lineHeight: 1.55 }}>{body}</div>
    </div>
  );
}
